import { TenderAnswer } from "./tendering";

// taskTypeID for a user's request to join a user group / gain access to a ramavtal
export const TENDERING_ACCESS_REQUEST_TASK_TYPE_ID = 5;

// Distinguishes a TenderingAccessRequest task asking to join a group from one asking to leave it.
// Missing/undefined on older tasks means Join (matches the backend DTO's default).
export type TenderingAccessRequestType = 'Join' | 'Leave';

export interface Task {
  taskID: number;
  taskTypeID: number;
  taskDepartmentID: number;
  taskModuleID: number;
  taskApprovedByUserID: number;
  taskIssuedByUserID: number;
  isTaskApproved: boolean;
  isTaskCompleted: boolean;
  taskData: TaskData;
  taskName: string;
  taskComment?: string;
  taskOwner?: number;
  taskDescription: string;
  taskProcessDate: Date;
  taskProcessedDate: Date;
}

export interface TaskListItem {
  taskID: number;
  taskTypeID: number;
  taskType: string;
  taskDepartmentID: number;
  taskModuleID: number;
  taskApprovedByUserID: number;
  taskIssuedByUserID: number;
  isTaskApproved: boolean;
  isTaskCompleted: boolean;
  taskData: TaskData | string;
  taskName: string;
  taskComment?: string;
  taskOwner?: number;
  taskMessage: string;
  taskDescription: string;
  taskProcessDate: Date;
  taskProcessedDate: Date;
  taskCreated: Date;
  taskUpdated: Date;
}

export interface CreateTask {
  taskName: string;
  taskDescription: string;
  taskData: TaskData;
  taskComment?: string;
  taskOwner?: number;
  taskModuleID?: number;
}

export interface UpdateTask {
  isTaskApproved?: boolean;
  taskComment?: string;
  taskOwner?: number;
}

export interface TaskData {
  notificationTypes?: number[];
  notifySubscribers?: boolean;
  isNotificationRead?: boolean;
  IsNotificationRead?: boolean;
  // Backend serializes this enum as a number (0 = Join, 1 = Leave); older tasks may have the string instead
  RequestType?: TenderingAccessRequestType | number;
  requestType?: TenderingAccessRequestType | number;
  [key: string]: any;
}

export interface ChangeRequestTaskData extends TaskData {
  documentID: string;
  tenderModuleID: number;
  oldAnswer: TenderAnswer;
  newAnswer: TenderAnswer;
  question: string;
}

export interface AccountRequestTaskData extends TaskData {
  departmentGroupID: number;
  email: string;
  firstName: string;
  lastName: string;
  title?: string;
  phoneNumber?: string;
  password?: string;
}
